/*
 * Application Data Module
 *
 * The Rails application will bootstrap data in a window.appData variable
 * Returns the value of the entire appData object, along with a getter
 * function to return only the data from a specific object key
 */

const value = (window && typeof window.appData === 'object' && window.appData) || {}

export default {
  value: value,
  get: (key) => {
    return value[key] || null
  }
}



// WEBPACK FOOTER //
// ./frontend/src/helpers/app-data.js